import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import SelectionBox from './../blocks/SelectionBox';

// Importuojame paveiksliukus
import pic1 from '../../../assets/img/icons/briaunos/1.jpg';
import pic2 from '../../../assets/img/icons/briaunos/2.jpg';
import pic3 from '../../../assets/img/icons/briaunos/3.jpg';
import pic4 from '../../../assets/img/icons/briaunos/4.jpg';
import pic5 from '../../../assets/img/icons/briaunos/5.jpg';
import pic6 from '../../../assets/img/icons/briaunos/6.jpg';
import pic7 from '../../../assets/img/icons/briaunos/7.jpg';
import pic8 from '../../../assets/img/icons/briaunos/8.jpg';
import pic9 from '../../../assets/img/icons/briaunos/9.jpg';
import pic10 from '../../../assets/img/icons/briaunos/10.jpg';
import pic11 from '../../../assets/img/icons/briaunos/11.jpg';
import pic12 from '../../../assets/img/icons/briaunos/12.jpg';
import pic13 from '../../../assets/img/icons/briaunos/13.jpg';

// SVARBU: Eksportuojame masyvą, kad jį matytų ConfigPanel.jsx
export const edgesOptions = [
    { image: pic1, title: 'Durelės dengia briaunas' },
    { image: pic2, title: 'Matosi visos' },
    { image: pic3, title: 'Matosi viršus ir apačia' },
    { image: pic4, title: 'Matosi viršus' },
    { image: pic5, title: 'Matosi išorinės' },
    { image: pic6, title: 'Be stogelio (matosi šonai)' },
    { image: pic7, title: 'Su stogeliu (matosi visos)' },
    { image: pic8, title: 'Durelės dengia briaunas' },
    { image: pic9, title: 'Matosi šonai' },
    { image: pic10, title: 'Matosi viršus ir šonai' },
    { image: pic11, title: 'Matosi išorinės ir vertikalios' },
    { image: pic12, title: 'Matosi išorinės ir horizontalius' },
    { image: pic13, title: 'Matosi šonai' }
];

const useStyles = makeStyles({
    // CSS grid + repeat(auto-fit,...) su fiksuoto pločio SelectionBox (type=column,
    // justifySelf:start) palikdavo tuščius grid langelius kaip pilno pločio "tarpus",
    // kai stulpelių daugiau nei realių elementų (žr. /admin/bugs "Ta pati grid
    // problema, nenaudojam grid" — bendra taisyklė visiems dialogams). flex+wrap+gap
    // vietoj grid — kiekvienas elementas užima tik savo turinio plotį.
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
});

const Edges = ({ edges, setEdges, onClose }) => {
    const s = useStyles();

    const handleOptionSelect = (index) => {
        if (setEdges) {
            setEdges(index);
        }
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className={s.grid}>
            {edgesOptions.map((option, index) => (
                <SelectionBox
                    key={index}
                    image={option.image}
                    title={option.title}
                    selected={edges === index}
                    onClick={() => handleOptionSelect(index)}
                />
            ))}
        </div>
    );
};

export default Edges;
